import isHotkeyLib, { type HotKeyOptions, type KeyboardEventLike } from 'is-hotkey'

/** @note we wrap this to get around some type issues */
export const isHotkey = (hotkey: string | readonly string[], options?: HotKeyOptions | undefined) =>
  isHotkeyLib(hotkey, options) as (ev: KeyboardEventLike) => boolean
